module.exports = __webpack_public_path__ + "static/media/record.5eab55d8.gif";